<template>
  <div>
    <v-container>
      <v-layout class="notificationbox">
        <template>
          <v-card class="imagebox" outlined>
            <v-row>
              <v-col>
                <div class="card">
                  <div class="text">
                    <div class="icon">
                      <img :src="userActive" />
                    </div>
                    <div class="navigations">
                      <h4>Permanently Close Account</h4>
                      <router-link to="/permanently-close-account"
                        ><img :src="arrowRight" />
                      </router-link>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col>
                <div class="card">
                  <div class="text">
                    <div class="icon">
                      <img :src="userDisabled" />
                    </div>
                    <div class="navigations">
                      <h4>Temporarily Deactivate Account</h4>
                      <img :src="arrowRight" @click="nextPage()"
                      />
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: "AccountManagement",
  data: function () {
    return {
      userActive: "./user-active.svg",
      userDisabled: "./user-disable.svg",
      arrowRight: "./arrow-right.svg",
    };
  },
  methods:{
    nextPage(){
      let response = this.$store.getters.getInvestometerDetail;
      if(response.data.deactivated ==1){
        swal.fire({
            title: '',
            text: "Account has been already deactivated",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            this.$loading(false);
          })   
      }
      else{
         this.$router.push("/deactivate-account");
        
      }
      
     
    }
  }
};
</script>

<style>
</style>